import * as XLSX from 'xlsx-js-style';
import type { ExcelTemplate } from '../../interfaces';
import { withHeaderStyling, withAllColumnsWidth, withColumnsWithValuesWidth } from '../../utils';
import { getPreparedData } from './mappings';
import { getHeaders } from './headers';
import { getColumnsWidths } from './styles';
import { RoundTableExcel } from 'src/app/domain/company-performance/round/round-table/round-table.component';

export class SingleCompanyRoundsByPeriodTemplate implements ExcelTemplate {
  export(data: RoundTableExcel): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  /**
   * Here I'm using array of arrays, because I need prepare cells properly with
   * format, styles, etc.
   */
  private getSheet(data: RoundTableExcel): XLSX.WorkSheet {
    const headers = getHeaders();
    const preparedData = getPreparedData(data, headers);
    const sheet = XLSX.utils.aoa_to_sheet(preparedData);
    return withColumnsWithValuesWidth(withAllColumnsWidth(withHeaderStyling(sheet)), getColumnsWidths());
  }
}

